import { BoardMemberFunctions } from 'shared/models/User'
import { getBoardSizeBasedOnMemberFunction } from 'shared/store/board/selectors'
import { RootState } from 'shared/store/store'
import { roleSorter } from 'shared/utils/roleSorter'
import {
  BoardMeetingPatchPaths,
  BoardMeetingProccessingState,
  IBoardDetailMeeting,
  IBoardMeetingParticipantForEdit,
} from '../../models/BoardMeeting'

export interface SystemState {
  boardmeetings: {
    meeting: {
      data: IBoardDetailMeeting
      loading: boolean
      error: string
      currentlyPatching?: BoardMeetingPatchPaths[]
      processing?: BoardMeetingProccessingState
      initiallySaved: boolean

      invited: {
        loading: boolean
        loadingAll: boolean
        error: string | null

        // if array, sending specific ids, if boolean, its "sending all"
        isSending: boolean | string[] | null
      }

      participantUpdate: {
        error: null | string
      }

      participantsForEdit: {
        data: IBoardMeetingParticipantForEdit[] | null
        loading: boolean
        error: string | null
      }
    }
  }
}

export const getBoardMeeting = (state: SystemState) =>
  state.boardmeetings.meeting

export const getParticipantsInitiallySaved = (state: SystemState) => {
  const meeting = getBoardMeeting(state)
  return meeting.initiallySaved
}

export const getMeetingParticipants = (state: SystemState) => {
  const meeting = getBoardMeeting(state)
  if (meeting.data)
  return roleSorter(meeting.data.participants, 'boardFunction', 'name')
  return []
}

export const getInvitedParticipants = (state: SystemState) => {
  const meeting = getBoardMeeting(state)
  return meeting.invited
}

export const getParticipantsForEdit = (state: SystemState) => {
  const meeting = getBoardMeeting(state)

  const data = meeting.participantsForEdit.data
    ? roleSorter(meeting.participantsForEdit.data, 'boardFunction', 'name')
    : []
  return {
    loading: meeting.participantsForEdit.loading,
    error: meeting.participantsForEdit.error,
    data,
  }
}

export const getMaxBoardSizeForSteeringCommittee = (state: RootState) => {
  const meeting = getBoardMeeting(state)

  const roles = [
    BoardMemberFunctions.BoardLeader,
    BoardMemberFunctions.BoardDeputyLeader,
    BoardMemberFunctions.BoardMember,
  ]

  const sizeFromBoard = getBoardSizeBasedOnMemberFunction(state)

  const steeringParticipants = meeting?.data?.participants?.filter(
    ({ boardFunction }) => roles.some((role) => role === boardFunction)
  )

  const sizeFromMeetingParticipants = steeringParticipants.length

  if (sizeFromBoard > sizeFromMeetingParticipants) return sizeFromBoard
  return sizeFromMeetingParticipants
}
